import React from 'react';
import {OrbitComponent} from "../../../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {AmountBox} from "../boxes/amount/amount.box";
import {AmountLabelBox} from "../boxes/amount/label/amount-label.box";
import {AmountValueBox} from "../boxes/amount/value/amount-value.box";

interface AmountComponentProps {
    label: string;
    amount: number;
}

export const AmountComponent = observer(class AmountComponent extends OrbitComponent<AmountComponentProps> {
    render() {
        return (
            <AmountBox>
                <AmountLabelBox>
                    {this.props.label}
                </AmountLabelBox>
                <AmountValueBox>
                    {this.services.currency.formatMoney(this.props.amount)}
                </AmountValueBox>
            </AmountBox>
        )
    }
});